import NavLayout from '@components/layouts/NavLayout.tsx';
import MainNav from '@components/main-nav/MainNav';

const WorkflowsOutlet = () => {
  return <NavLayout navbar={<MainNav />} />;
};

export default WorkflowsOutlet;
